import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MUIListItemText, { ListItemTextProps } from '@material-ui/core/ListItemText';

function ListItemText({ classes, ...restOfProps }: ListItemTextProps) {
  const _classesOverride = useStyles();
  const classesOverride = !!classes ? classes : _classesOverride;

  return <MUIListItemText classes={classesOverride} {...restOfProps} />;
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    fontWeight: 600,
    fontSize: 16,
  },
  primary: {
    fontWeight: 400,
    fontSize: 'inherit',
  },
}));

export default ListItemText;
